import { render, staticRenderFns } from "./NewspaperListing.vue?vue&type=template&id=70d1510a&scoped=true"
import script from "./NewspaperListing.vue?vue&type=script&lang=js"
export * from "./NewspaperListing.vue?vue&type=script&lang=js"
import style0 from "./NewspaperListing.vue?vue&type=style&index=0&id=70d1510a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d1510a",
  null
  
)

export default component.exports